import type { PlayerProfile } from '../profile/schema';
import { firstAtlasState } from './goals';

export const FIRST_ATLAS_LETTER = {
  id: 'first-atlas-letter', title: 'The First Atlas',
  body: 'You have given one quarry half an hour of patient study and brought back marks from both Murrin grounds. The chart-room has its first dependable pages. That is enough for an atlas to begin. Keep the boat, keep the records, and follow whichever water calls next.',
  signature: 'The Harbourmaster, Murrin',
} as const;
/** Reading the ending records a letter only. No economy or voyage state is reset. */
export function finishAtlas(profile: PlayerProfile): PlayerProfile {
  if (firstAtlasState(profile) === 'in-progress') return profile;
  return { ...profile, endingSeen: true, letters: profile.letters.includes(FIRST_ATLAS_LETTER.id) ? profile.letters : [...profile.letters, FIRST_ATLAS_LETTER.id] };
}
export function continueFishing(profile: PlayerProfile): PlayerProfile {
  const next = finishAtlas(profile);
  if (!next.endingSeen) return next;
  return { ...next, milestones: next.milestones.includes('first-atlas-continued') ? next.milestones : [...next.milestones, 'first-atlas-continued'] };
}
